module.exports = __webpack_public_path__ + "static/mcdonalds-logo-2c82ba1301bfdf9704abab90d547211b.png";